import { Action } from '@ngrx/store';

import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

export const GET_OPPORTUNITY_TYPE = '[opportunities] Get Opportunity';
export const GET_OPPORTUNITY_FAIL_TYPE = '[opportunities] Get Opportunity Fail';
export const ADD_TO_SET_OPPORTUNITIES_STATE_TYPE = '[opportunities] Add To Set';
export const OPPORTUNITY_STATUS_CHANGE_TYPE = '[opportunities] Status Change';
export const PATCH_OPPORTUNITY_TYPE = '[opportunities] Patch Opportunity';

export class OpportunityActions implements Action {
  constructor(public type = '', public payload: any) {}
}

export function GetOpportunity(payload?: any) {
  return new OpportunityActions(GET_OPPORTUNITY_TYPE, payload);
}

export function GetOpportunityFail(payload?: any) {
  return new OpportunityActions(GET_OPPORTUNITY_FAIL_TYPE, payload);
}

export function AddToSetOpportunitiesState(payload?: any) {
  return new OpportunityActions(ADD_TO_SET_OPPORTUNITIES_STATE_TYPE, payload);
}

export function PatchOpportunity(opportunity: Opportunity) {
  return new OpportunityActions(PATCH_OPPORTUNITY_TYPE, opportunity);
}

export function ChangeOpportunityStatus(payload: {
  opportunityId: string;
  status: string;
}) {
  return new OpportunityActions(OPPORTUNITY_STATUS_CHANGE_TYPE, payload);
}
